import React, { useEffect, useState } from "react";
import Select from "react-select";
import axios from "axios";

const ReportingSelect = ({ value, onChange }) => {
  const [reportingData, setReportingData] = useState([]);
  const [loading, setLoading] = useState(true);

  // Custom styles for the Select component
const customStyles = {
  control: (provided) => ({
    ...provided,
    backgroundColor: '#f9f9f9', // Apply background color
    borderColor: '#ddd', // Apply border color
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 9999, // Ensure dropdown appears above other elements
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#666666', // Customize placeholder color
  }),
};


  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/employees/list?listtype=basic`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        const transformedData = response.data.employees.map((employee) => ({
          value: employee.id,
          label: employee.name,
        }));
        setReportingData(transformedData);
      } catch (error) {
        console.error("Error fetching reporting data:", error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleSelectChange = (selectedOption) => {
    onChange(selectedOption);
  };

  return (
    <Select
      options={reportingData}
      placeholder={loading ? "Loading Employees ..." : "Select employee "}
      isLoading={loading}
      value={value ? reportingData.find((report) => report.value === value.value) || null : null}
      onChange={handleSelectChange}
      styles={customStyles}
      isClearable
    />
  );
};


export default ReportingSelect;
